export default __webpack_public_path__ + "1fa23bef730fc7a348bf7f3a4568a073.png";